import React from 'react';
import PropTypes from 'prop-types';
import Styles from "../../../css";

// Removed react-toggle dependency - using custom styled checkbox instead

import Input from "./Input.jsx";

/* other constants */
const inputHeight = 36; // pixels
const inputIDFormat = "input_";

const titleStyle = Styles.combineStyles(
    Styles.fonts.commonFont,
    Styles.fonts.miniTitle
);

const descriptionStyle = Styles.combineStyles(
    Styles.fonts.commonFont,
    Styles.general.faded
);
let inputStyle = Styles.combineStyles(
    Styles.fonts.commonFont,
    Styles.input,
    Styles.general.expanded
);

class InputContainer extends React.Component {

    constructor() {
        super();

        this.state = {
            height: 0 // In pixels, for later vertical centering
        };
    }

    render() {
        // Add margin-top to the input so that it will be vertically centered
        let marginTop = (this.state.height - inputHeight) / 2;
        inputStyle = Styles.combineStyles(inputStyle, {marginTop});

        const {
            title, description, isTextArea, type, placeholder, identifier,
            valueUpdate, inputValue, inputProps, shouldAutoComplete,
            onOptionSelection, availableOptions, immutable, resetOnSelection,
            ...otherProps // Collect any other props like 'id'
        } = this.props;

        // Determine if the input will be "input", "checkbox" or "textarea"
        let theInput = <Input inputProps={Object.assign({
            style: inputStyle,
            type: type,
            placeholder: placeholder,
            onChange: valueUpdate,
            value: inputValue,
        }, (immutable ? {disabled: true} : {}), inputProps, otherProps)}
                              shouldAutoComplete={ shouldAutoComplete }
                              onOptionSelection={  onOptionSelection }
                              availableOptions={   availableOptions }
                              resetOnSelection={   resetOnSelection }
        />;

        if (isTextArea)
            theInput = <textarea {...inputProps} {...otherProps} style={inputStyle} placeholder={ placeholder }
                                 onChange={ valueUpdate } value={ inputValue }
                                 disabled={immutable}></textarea>;
        else if(type == "checkbox") {
            // The input itself is rendered invisible, so the only thing a user can click is
            //  the label, and the label reaches the input through this id. Callers pass an
            //  id of their own and then look the field up by it, so theirs wins and the
            //  label points at that; the generated one is only for callers that pass none.
            //  Applied after the prop spreads so the pair cannot come apart.
            const toggleId = otherProps.id || `toggle-${identifier}`;
            theInput = (
                <label htmlFor={toggleId} style={{
                    position: 'relative',
                    display: 'inline-block',
                    width: '60px',
                    height: '34px',
                    verticalAlign: 'middle',
                    float: 'right'
                }}>
                    <input
                        type="checkbox"
                        {...inputProps}
                        {...otherProps}
                        id={toggleId}
                        onChange={valueUpdate}
                        checked={inputValue === "true" || inputValue === true}
                        style={{
                            opacity: 0,
                            width: 0,
                            height: 0,
                            position: 'absolute'
                        }}
                    />
                    <span style={{
                        position: 'absolute',
                        cursor: 'pointer',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: (inputValue === "true" || inputValue === true) ? 'rgb(112, 38, 138)' : '#ccc',
                        transition: '.4s',
                        borderRadius: '34px',
                        display: 'block'
                    }}>
                        <span style={{
                            position: 'absolute',
                            height: '26px',
                            width: '26px',
                            left: (inputValue === "true" || inputValue === true) ? '30px' : '4px',
                            bottom: '4px',
                            backgroundColor: 'white',
                            transition: '.4s',
                            borderRadius: '50%',
                            display: 'block'
                        }}></span>
                    </span>
                </label>
            );
        }


        return (
            <div className="row" style={ Styles.general.spaceDown } id={inputIDFormat + identifier}>
                <div className="col-xs-12">
                    <div className="input-title" style={ titleStyle }>{ title }</div>
                    <div className="input-desc" style={ descriptionStyle }>{ description }</div>
                </div>
                <div className="col-xs-12">
                    { theInput }
                </div>
            </div>
        );
    }

    // The following is updating the height after rendering, in order to make the
    //  input itself vertically centered
    componentDidMount() {
        const height =
            document.getElementById(inputIDFormat + this.props.identifier).clientHeight;
        this.setState({height});
    }
}

// Component prop types
InputContainer.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string, // The text below the input title
    isTextArea: PropTypes.bool,
    type: PropTypes.string, // e.g. "text", "checkbox", "phone"...
    placeholder: PropTypes.string,
    identifier: PropTypes.number.isRequired, // For id generation. Must be unique
    valueUpdate: PropTypes.func, // to be called each time the input is changed.
    // Signarture: func(event, { newValue })
    inputValue: PropTypes.string, // The value of the input
    inputProps: PropTypes.object, // Parameters which will be passed to the input
                                // Note that some input types accept only certian
                                //  props, like the checkbox

    // Autocomplete
    shouldAutoComplete: PropTypes.bool.isRequired, // whether to Autocomplete
    onOptionSelection: PropTypes.func, // The function to be executed when selecting.
                                       // the header: func(objectSelected)
    availableOptions: PropTypes.array, // of objects with the key "value" as string
    immutable: PropTypes.bool, // If true, will not allow to change
    resetOnSelection: PropTypes.bool,  // Wether to erease the input after selecting
                                       // an option (if autocomplete is enabled)

}

InputContainer.defaultProps = {
    description: "",
    isTextArea: false,
    type: "text",
    immutable: false,
    placeholder: "",
    shouldAutoComplete: false,
    resetOnSelection: false,
    inputProps: {}
}

export default InputContainer;
